import { transactionService } from '../services'

export default (paramId) => {
	return new Promise(resolve => {
		transactionService.getValoresParametroCliente(paramId)
			.then(response => resolve(response.data))
	})
}
